import objectFitImages from 'object-fit-images';

import Home from './renderers/home';
import Singular from './renderers/singular';
import Nav from './components/nav';
import Map from './components/map';
import Cta from './components/cta';

objectFitImages();

document.addEventListener('DOMContentLoaded', () => {
	// DOM loaded
    if (document.body.classList.contains('home')) {
    	new Home();
    } else {
    	new Singular();
    }
    new Nav();
    new Map();
    new Cta();
});